module.exports = __webpack_public_path__ + "static/img/border2_bottoml.c022afd0.png";